var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00028 1.4654H9.85742C9.936 1.4654 10.0003 1.40112 10.0003 1.32254V0.322545C10.0003 0.243973 9.936 0.179688 9.85742 0.179688H1.00028C0.921708 0.179688 0.857422 0.243973 0.857422 0.322545V1.32254C0.857422 1.40112 0.921708 1.4654 1.00028 1.4654ZM1.00028 9.03683H9.85742C9.936 9.03683 10.0003 8.97255 10.0003 8.89397V7.89397C10.0003 7.8154 9.936 7.75112 9.85742 7.75112H1.00028C0.921708 7.75112 0.857422 7.8154 0.857422 7.89397V8.89397C0.857422 8.97255 0.921708 9.03683 1.00028 9.03683ZM15.0003 11.5368H1.00028C0.921708 11.5368 0.857422 11.6011 0.857422 11.6797V12.6797C0.857422 12.7583 0.921708 12.8225 1.00028 12.8225H15.0003C15.0789 12.8225 15.1431 12.7583 15.1431 12.6797V11.6797C15.1431 11.6011 15.0789 11.5368 15.0003 11.5368ZM15.0003 3.9654H1.00028C0.921708 3.9654 0.857422 4.02969 0.857422 4.10826V5.10826C0.857422 5.18683 0.921708 5.25112 1.00028 5.25112H15.0003C15.0789 5.25112 15.1431 5.18683 15.1431 5.10826V4.10826C15.1431 4.02969 15.0789 3.9654 15.0003 3.9654Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLeft);
export default __webpack_public_path__ + "static/media/align-left.895a59977fa7e490552019eba3e103f7.svg";
export { ForwardRef as ReactComponent };